import { ObjectID } from 'bson';

export const starObjectIds = {
  '1': new ObjectID('5d0b2009cc58d80008f039e4'),
  '2': new ObjectID('5d0b2009cc58d80008f039e5'),
  '3': new ObjectID('5d0b2009cc58d80008f039e7'),
  '4': new ObjectID('5d0b2009cc58d80008f039e6'),
  '5': new ObjectID('5d0b2009cc58d80008f039e8'),
};
